// extracted by mini-css-extract-plugin
export default {"intro":"home_intro__D4irp","categories":"home_categories__JH798","card":"home_card__qhPGx","mainInfo":"home_mainInfo__KfoBA","mainTitle":"home_mainTitle__Ga-Zv"};